"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticUpdateInfo = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var CabucStatusInfo_module_css_1 = tslib_1.__importDefault(require("./CabucStatusInfo.module.css"));

var classnames_1 = tslib_1.__importDefault(require("classnames"));

var Button_1 = require("@skbkontur/react-ui/components/Button");

var configuration_1 = require("../../../contexts/configuration");

var StaticUpdateInfo =
/** @class */
function (_super) {
  tslib_1.__extends(StaticUpdateInfo, _super);

  function StaticUpdateInfo() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onClick = function (e) {
      e.stopPropagation();
      var staticUpdateInfo = _this.props.item.staticUpdateInfo;

      _this.context.trackEvent('StaticCertUpdate', staticUpdateInfo.type);

      window.location.assign(staticUpdateInfo.updateUrl);
    };

    return _this;
  }

  StaticUpdateInfo.prototype.render = function () {
    var item = this.props.item;
    var staticUpdateInfo = item.staticUpdateInfo;
    var _a = staticUpdateInfo,
        buttonText = _a.buttonText,
        textBeforeButton = _a.textBeforeButton,
        updateUrl = _a.updateUrl;
    return react_1.default.createElement("div", null, updateUrl && react_1.default.createElement("div", {
      className: CabucStatusInfo_module_css_1.default.pad
    }, react_1.default.createElement("div", {
      className: classnames_1.default(CabucStatusInfo_module_css_1.default.message, CabucStatusInfo_module_css_1.default.gray)
    }, react_1.default.createElement("div", {
      className: CabucStatusInfo_module_css_1.default.red
    }, "\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 ", this.context.certificateProcessor.getValidToMessage(item)), react_1.default.createElement("div", null, textBeforeButton)), react_1.default.createElement("div", {
      className: CabucStatusInfo_module_css_1.default.buttonWrap
    }, react_1.default.createElement(Button_1.Button, {
      use: "primary",
      onClick: this.onClick
    }, buttonText))));
  };

  StaticUpdateInfo.contextType = configuration_1.configurationContext;
  return StaticUpdateInfo;
}(react_1.default.Component);

exports.StaticUpdateInfo = StaticUpdateInfo;